export {
  MatchInterviewType,
  SHORT_INTERVIEW_TYPES,
  LONG_INTERVIEW_TYPES,
  NO_ICS_ATTACHMENT_INTERVIEW_TYPES,
} from '@pflegia/types/common/enums/interviews/match-interview-type';
